import { createFileRoute } from '@tanstack/react-router';
import Settings from '../Screens/Settings';

export const Route = createFileRoute('/settings')({
  component: Settings,
});